//
//
//
//
//
//
//
//

import TransitionFade from "../transitions/Fade.vue";
import { mapGetters } from "vuex";
export default {
  name: "AppDetail",
  props: ["detail"],
  components: {
    TransitionFade,
  },
  computed: {
    ...mapGetters(["width"]),
  },
};
